import { useState, useMemo } from 'react';

export default function CTA() {
  const [showQRCode, setShowQRCode] = useState(false);

  const deadline = useMemo(() => {
    const initialDate = new Date('2026-03-30');
    const now = new Date();
    
    if (now > initialDate) {
      const monthsDiff = (now.getFullYear() - initialDate.getFullYear()) * 12 + (now.getMonth() - initialDate.getMonth());
      const monthsToAdd = Math.floor(monthsDiff / 1) + 1;
      const newDate = new Date(initialDate);
      newDate.setMonth(initialDate.getMonth() + monthsToAdd);
      return newDate;
    }
    
    return initialDate;
  }, []);

  const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    return `${year}年${month}月30日`;
  };

  return (
    <>
      <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-gradient-to-br from-blue-500 via-purple-500 to-blue-600 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-64 h-64 sm:w-96 sm:h-96 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-64 h-64 sm:w-96 sm:h-96 bg-white rounded-full blur-3xl"></div>
        </div>
        
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center relative z-10">
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-white mb-4 sm:mb-5 px-2 sm:px-4">
            免费试用15天，专业团队全程指导
          </h2>
          <p className="text-white/90 text-sm sm:text-base md:text-lg mb-6 sm:mb-8 px-2 sm:px-4">
            限时领取截止时间：{formatDate(deadline)}
          </p>
          <div className="flex justify-center items-center px-2 sm:px-4">
            <button 
              onClick={() => setShowQRCode(true)}
              className="inline-flex items-center justify-center gap-2 px-8 sm:px-12 md:px-14 py-3 sm:py-3.5 md:py-4 bg-white text-blue-600 text-sm sm:text-base font-semibold rounded-full hover:shadow-2xl transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              马上试用
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </section>

      {showQRCode && (
        <div
          className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center px-4"
          onClick={() => setShowQRCode(false)}
        >
          <div
            className="bg-white rounded-2xl p-6 sm:p-8 max-w-sm w-full mx-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center mb-4 sm:mb-6">
              <h3 className="text-lg sm:text-xl font-semibold text-gray-800">扫码免费体验</h3>
              <button
                onClick={() => setShowQRCode(false)}
                className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>
            <div className="bg-gray-100 p-4 sm:p-6 rounded-xl">
              <img
                src="https://static.readdy.ai/image/c9656b810d2c6cc0a8672cac16e7cf96/e7f95b852e2d7fc033ed8e2278921757.png"
                alt="QR Code"
                className="w-full h-auto"
              />
            </div>
            <p className="text-center text-xs sm:text-sm text-gray-500 mt-3 sm:mt-4">使用微信扫描二维码</p>
          </div>
        </div>
      )}
    </>
  );
}